import { ActionButton, actionButtonStyles } from "./ActionButton";

interface DeleteButtonProps {
  onDelete: () => void;
  canDelete?: boolean;
}

export function DeleteButton({ onDelete, canDelete = true }: DeleteButtonProps) {
  if (!canDelete) return null;

  return (
    <ActionButton
      icon="trash-can-outline"
      onPress={onDelete}
      tooltip="Delete"
      style={actionButtonStyles.iconBtn}
      tooltipOffsetX={-12}
    />
  );
}
